import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FDFDFB]">
      <header className="border-b border-[#E2E8E4]">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center">
            <Logo />
          </Link>
          <Link to="/" className="text-xs text-[#5C6661] inline-flex items-center gap-1 hover:text-[#121413]"><ArrowLeft className="w-3 h-3" /> Home</Link>
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-6 pt-10">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1586769852044-692d6e3703f0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600"
            alt="Envelopes and a fountain pen"
            className="w-full h-36 md:h-44 object-cover"
            onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600"; }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#2D4A3E]/60 via-[#2D4A3E]/20 to-transparent" />
          <div className="absolute inset-0 flex items-center px-8 md:px-10">
            <div className="text-white">
              <div className="inline-block overline text-white/70">Legal</div>
              <div className="font-display text-2xl md:text-3xl font-extrabold tracking-tight mt-1">Fine print, kept sensible.</div>
            </div>
          </div>
        </div>
      </div>
      <main className="max-w-3xl mx-auto px-6 pt-10 pb-16">
        <div className="overline">Legal</div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight mt-2">Terms of Service</h1>
        <p className="text-xs text-[#5C6661] mt-2">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="mt-10 space-y-6 text-sm text-[#5C6661] leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Using JobKnocker</h2>
            <p className="mt-2">JobKnocker helps you send speculative applications to companies that fit your professional profile, from your own email inbox. You are responsible for what you send and to whom. Please respect anti-spam laws in your jurisdiction (GDPR, CAN-SPAM, CASL, etc.) — do not use the tool to send bulk unsolicited marketing.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Your account</h2>
            <p className="mt-2">You must be at least 16 to use JobKnocker. Keep your login credentials secure. You&apos;re responsible for activity from your account.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Subscriptions</h2>
            <p className="mt-2">JobKnocker Pro is £4.99 per month. On the web it&apos;s billed by Stripe; on iOS it&apos;s billed by Apple. One active subscription unlocks Pro on all your devices under the same account. Cancel any time — where you subscribed is where you cancel.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Refunds</h2>
            <p className="mt-2">Web subscriptions are refundable within 7 days of the initial charge if you haven&apos;t sent more than 20 applications on Pro. Apple purchases follow Apple&apos;s refund policy.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Limitation of liability</h2>
            <p className="mt-2">JobKnocker is provided as-is. We don&apos;t guarantee replies from companies, employment outcomes, or accuracy of AI output — please review every application before hitting send.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#121413]">Contact</h2>
            <p className="mt-2"><span className="font-mono">support@job-knocker.com</span></p>
          </section>
        </div>
      </main>
    </div>
  );
}
